import React, { useEffect, useState } from 'react'
import Header from '../../components/header'
import CustomSelect from '../../components/customSelect'
import Table from '../../components/table'
import { publicSchoollistColumn } from '../../v2/utility/publicSchoolList'
import Button from '../../components/buttonPrimary'
// import * as APIs from "../../../pages/registrationPage/apis";
import * as APIs from "../../pages/registrationPage/apis";
import { hideLoader, notify, notifyError, showLoader } from '../../components/loader'
const PublicSchoolcontainer = () => {
const [districtDropDown, setDistrictdropDown] = useState([])
const [allBlock,setAllBlock]= useState([])
const [state, setState] = useState({
    district: '',
    block: '',
})
const [allSchool, setAllSchool] = useState([])

      useEffect(() => {
        const fetchData = async () => {
          const res = await APIs.getMasterData({
            tablesName: [
              "master_district",
            ],
          });
          if (res.status) {
            setDistrictdropDown(res.data);
          }
        };
        fetchData();
      }, []);
      console.log(districtDropDown)

      const handleChange = (e) => {
        setState({...state, [e.target.name]: e.target.value });
      };
      useEffect(() => {
          if (state.district) {
            const getData = async () => {
              let res = await APIs.getCustoDropdown({
                dropdown_code: "block_master",
                districtId: [state.district],
              });
              setAllBlock(res.data);
            };
            getData();
          }
        }, [state.district]);

        const onDistrictOrBlock = async(districtId, blockId) => {
            
            if(!districtId){
                notifyError( "Please select District");
               return 
            }
            else if(!blockId){
                notifyError( "Please select Block");
               return 
            }
            showLoader()
            if (districtId && blockId) {
              
                let res = await APIs.getCustoDropdown({
                  dropdown_code: "school_master",
                  districtId: [districtId],
                  blockId: [blockId],
                });
                console.log(res)
                if(res.status){
                    setAllSchool(res.data.map((d, index)=>({s_n : index+1, schoolName: d?.schoolName, address:d?.schoolAddress1})))
                    hideLoader()
                }
           
          };
        }
  return (
    <div >
         <Header header_text="Search School Details" />
         <div className='flex justify-end'>

        
         <div className='w-1/2  flex gap-4 py-6 px-10'>
         <CustomSelect
                options={districtDropDown?.masterDistrict}
                // star="*"
                placeholder="Select District"
                // second_class={classes.medium}
                onChange={(e) => handleChange(e)}
                // value={state.gender}
                name="district"
                optionLabel="name"
                optionValue={"id"}
              />
         <CustomSelect
                options={allBlock}
                // label="2. Gender"
                // star="*"
                placeholder="Select Block"
                // second_class={classes.medium}
                onChange={(e) => handleChange(e)}
                // value={state.gender}
                name="block"
                optionLabel="blockName"
                optionValue={"blockId"}
              />
              <div>

              <Button  button_text="Search"
                  variant="button_blue"
                  
                  onClick={()=>onDistrictOrBlock(state.district, state.block)} 
                  />
              </div>
              </div>
         </div>
         <div className='px-10 pb-6'>

         <Table columns={publicSchoollistColumn} rows={allSchool}/>
         </div>
    </div>
  )
}

export default PublicSchoolcontainer